import React, { useEffect } from "react";
import { Button, NumberInput, ReferenceInput, required, SelectInput, useNotify } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import EditIcon from "@mui/icons-material/Edit";
import dataProvider from "server/dataProvider";
import { StudentStateExamStatus } from "utils/constants";
import { graduationRequests } from "api/graduationApi";
import { useFormContext, useWatch } from "react-hook-form";

const GradeField = () => {
  const { setValue } = useFormContext();
  const status = useWatch({ name: "status" });

  const isAttended = status === StudentStateExamStatus.Attended;
  const isDisqualified = status === StudentStateExamStatus.Disqualified;
  const isNotAttended = status === StudentStateExamStatus.NotAttended;

  useEffect(() => {
    if (isDisqualified) {
      setValue("grade", 2, { shouldValidate: true });
    } else if (isNotAttended) {
      setValue("grade", null, { shouldValidate: true });
    } else if (isAttended) {
      setValue("grade", null, { shouldValidate: false });
    }
  }, [status]);

  return (
    <NumberInput
      source="grade"
      label="Оценка"
      min={2}
      max={6}
      validate={isAttended ? required() : undefined}
      readOnly={!isAttended}
    />
  );
};

const UpdateStateExamDialog = ({ studentEducationId, stateExamId, defaultValues, fetchStateExamsResults }) => {
  const notify = useNotify();

  const handleSubmit = async data => {
    const payload = {
      grade: data.grade,
      points: data.points,
      status: data.status,
    };
    await dataProvider.customRequest(
      graduationRequests.stateExamStudentResult(stateExamId, studentEducationId),
      payload,
      "PUT",
    );
    notify("Успешно редактирахте резултат на държавен изпит", { type: "success" });
    fetchStateExamsResults();
  };

  return (
    <FormModal
      defaultValues={defaultValues}
      onConfirm={handleSubmit}
      titleContent="Промяна на резултат"
      triggerButton={
        <Button
          label="Редактирай резултат"
          startIcon={<EditIcon />}
        />
      }
    >
      <ReferenceInput
        source="status"
        reference={graduationRequests.getStateExamsStatusesSelect()}
      >
        <SelectInput
          optionText="nameBg"
          label="Статус"
          emptyText={false}
          validate={required()}
        />
      </ReferenceInput>
      <GradeField />
      <NumberInput
        source="points"
        label="Точки"
      />
    </FormModal>
  );
};

export default UpdateStateExamDialog;
